const quotes = [
  {
    id: 1,
    quote: 'The uniform character of mathematics is the essence of science, for mathematics is the foundation of all exact scientific knowledge.',
    name: 'David Hilbert',
    year: '1862 - 1943',
    title: 'Mathematician',
  },
  {
    id: 2,
    quote: 'Geometry is one and eternal shining in the mind of God. That men share in it is among the reasons that Man is the image of God.',
    name: 'Johannes Kepler',
    year: '1571 - 1630',
    title: 'Mathematician and Astronomer',
  },
  {
    id: 3,
    quote: 'Mathematics is the language in which the gods speak to people.',
    name: 'Plato',
    year: '427 BC - 347 BC',
    title: 'Mathematician and Philosopher',
  },
  {
    id: 4,
    quote: 'In my experience most mathematicians are intellectually lazy and especially dislike reading experimental papers.',
    name: 'Francis Crick',
    year: '1916 - 2004',
    title: 'Physicist & Molecular Biologist',
  },
  {
    id: 5,
    quote: 'The legend that every cipher is breakable is of course absurd, though still widespread among people who should know better.',
    name: 'J.E. Littlewood',
    year: '1885 - 1977',
    title: 'Mathematician',
  },
  {
    id: 6,
    quote: 'Surely it is not knowledge, but learning; not owning but earning; not being there, but getting there; that gives us the greatest pleasure.',
    name: 'Carl Friedrich Gauss',
    year: '1777 - 1855',
    title: 'Mathematician and Physicist',
  },
];

export default quotes;
